<template>

  <div class="middle-box text-center loginscreen animated fadeInDown">

    <div class="image-logo">
      <img src="/static/img/logo-ssparisi.png" alt="Logo">
    </div>

    <div style="margin-top: 10px;">
      <div class="m-b-md">
        <img alt="image" class="img-circle circle-border" :src="user.img || '/static/img/profile.jpg'">
      </div>

      <h3>{{ user.name }}</h3>
      <p><small>{{ user.email }}</small></p>

      <p> Sua tela foi bloqueada, é necessário digitar a senha para continuar </p>

      <form class="m-t" role="form">
        <div class="form-group">
          <input type="password" class="form-control" name="password" placeholder="******"
          v-model="password" v-validate="'required|min:4'" :class="{ invalid: errors.has('password') }" >
          <span class="error">{{ errors.first('password') }}</span>
        </div>

        <button class="btn btn-success block full-width" @click.prevent="loginBack()">Liberar</button>

        <a class="btn btn-success btn-outline block full-width" @click="logOut()"> <i class="fa fa-sign-out"></i> Sair </a>
      </form>
    </div>

  </div>

</template>

<script>

  import { httpService } from '../providers/http-service'
  import { mapGetters, mapActions } from 'vuex'
  import { toast } from '../mixins/toast'

  export default {
    mixins: [ toast ],
    data() {
      return {
        password: ''
      }
    },
    methods: {
      ...mapActions(['removeLoggedUser']),
      ...mapGetters(['getLoggedUser']),

      loginBack() {
        this.$validator.validateAll().then((valid) => {
          if(valid) {
            httpService.login({ email: this.user.email, password: this.password }).then((res) => {
              if(res.status === 200) {
                localStorage.setItem('token', res.data.token)
                this.$router.push({ path: '/home' })
              }
            }, (err) => {
              this.show_toast('warning', 'Não autorizado', err.response.data)
            })

          } else {
            this.show_toast('warning', 'Atenção', 'Verifique novamente os campos informados!')
          }
        })
      },

      logOut() {
        this.removeLoggedUser({})
        localStorage.removeItem('token')
        this.$router.push({ path: '/' })
      },

    },
    computed: {
      user() {
        return this.getLoggedUser()
      }
    }
  }
</script>

<style scoped>

  .image-logo { height: 120px; position: relative; }

  .image-logo img {
    display: block;
    max-width: 100%;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  div.m-b-md {
    margin: 10px;
    width: 100%;
    height: 200px;
    line-height: 115px;
    text-align: center;
  }

  img.img-circle.circle-border {
    max-width: 100%;
    max-height: 100%;
    vertical-align: middle;
  }

  button { margin-bottom: 10px; }

</style>



// WEBPACK FOOTER //
// src/components/LockScreenPage.vue